const About = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <script 
    src="https://kit.fontawesome.com/a6874c76aa.js" 
    crossorigin="anonymous"></script>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@300&display=swap" rel="stylesheet">
    <link href="https://fonts.googleapis.com/css2?family=Ubuntu+Condensed&display=swap" rel="stylesheet">
    <link href="https://fonts.googleapis.com/css2?family=Roboto+Slab&display=swap" rel="stylesheet">

    <link rel="stylesheet" href="./styles/common.css"/>
    <link rel="stylesheet" href="./styles/nav.css"/>
    <link rel="stylesheet" href="./styles/footer.css"/>
    <link rel="stylesheet" href="./styles/skewed-header.css"/>
    <link rel="stylesheet" href="./styles/page-container.css"/>
    <link rel="stylesheet" href="./styles/square-grid.css"/>
    <link rel="stylesheet" href="./styles/helpers.css"/>
    <link rel="stylesheet" href="./styles/media-queries.css"/>
    
    <title>About</title>
</head>
<body>
<div class="skewed-header">
    <div class="header-bg" style="background-image: url('/images/backgrounds/about-us.jpg');"></div>

    <div class="skewed-header-wrapper">
        <div class="skewed-header-content">
            <div class="heading-wrapper">
                <h1>About Us</h1>
            </div>

            <div class="links-wrapper">
                <div class="nav-link">
                    <a href="index.html">Home</a> 
                </div>
                <div class="nav-link">
                    <a href="about.html">About</a>
                </div>
                <div class="nav-link">
                    <a href="menu.html">Menu</a>
                </div>
                <div class="nav-link">
                    <a href="contact.html">Contact</a>  
                </div>                 
            </div>

        </div>
    </div>
</div>

<div class="page-container">
    <div class="content-wrapper">
        <img src="./images/people/chef.jpg" alt="Featured Chef" id="chef">
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum quidem eligendi, animi tempore ullam tenetur officia temporibus molestias voluptatem delectus corrupti possimus a beatae est tempora placeat, aut, qui reiciendis? Vel repellendus officia quaerat temporibus, suscipit distinctio qui. Impedit reprehenderit, beatae saepe numquam aperiam est omnis. Perspiciatis beatae placeat eaque harum voluptas voluptates, magni sapiente id? Sed iusto ullam, quam totam tempora praesentium officia maiores maxime fuga porro, harum temporibus, earum quos dolore repudiandae consectetur quo modi similique? Cupiditate nihil illo molestiae possimus vel iste eum ipsum tempore repudiandae neque fuga illum nesciunt nulla, ipsam, corporis facilis magnam? Ipsam quidem iusto asperiores dolor ipsa sequi repellat dolores saepe ullam, quas, eum aliquam consequuntur nobis, doloribus ratione veritatis ducimus necessitatibus illum placeat quis voluptas consectetur quam. Sint reiciendis repellendus quos repellat quis explicabo alias ratione cum fuga, quas autem atque perspiciatis distinctio cumque, doloribus ut laborum earum nesciunt quasi optio fugiat blanditiis magni accusamus. Culpa aliquam fugit quidem ut libero quae praesentium ipsam, repudiandae laborum magni! Culpa soluta fuga necessitatibus minus, minima sed nesciunt corporis optio voluptates molestiae, aut error aliquam aspernatur saepe officia fugit mollitia tempora iste, ratione aperiam. Alias eaque ex, sit in temporibus magni sint eum est repudiandae.</p>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse, soluta totam alias accusamus omnis dolore adipisci est, placeat quibusdam, velit sed. Quaerat cupiditate distinctio quia non nam molestiae soluta deserunt in et repellendus corporis amet adipisci, nemo vero quas officiis reprehenderit dolorum voluptatem voluptatum excepturi omnis, itaque animi sint. Eius voluptates veniam voluptatum, vero nemo a, blanditiis odio nesciunt porro beatae ipsa, non est nam debitis qui eum? Dolorum magni enim, totam itaque laboriosam, at corporis recusandae sequi possimus fuga, veritatis et non nulla sed incidunt in! Exercitationem suscipit ratione illo quaerat eius aperiam ea nemo, vitae ducimus temporibus officiis veniam unde expedita culpa fuga nesciunt! Odit maiores nostrum neque. Officia pariatur iste cumque omnis dignissimos enim magnam quibusdam voluptas corporis quos doloremque aut eveniet mollitia facilis, quis sit rem illum nisi eum laudantium exercitationem tempore inventore et! Non maxime nam delectus dolorem rem adipisci quisquam nemo, nulla asperiores dolores ipsam ad amet aspernatur ipsa! Cupiditate animi commodi impedit excepturi dolor tempora, aliquam velit minima! Sit, harum? Expedita totam natus nostrum ad, sapiente quisquam suscipit voluptatem mollitia fugiat molestiae fugit ducimus error explicabo debitis accusamus provident delectus voluptas beatae vero inventore corporis fuga minima minus earum. Distinctio laborum debitis eaque quo tempora labore ea explicabo quaerat adipisci a. Voluptate delectus expedita, eius officiis suscipit sunt illum explicabo dolor. Explicabo, saepe esse voluptatum vitae a recusandae vel repudiandae corrupti officia non at illum est placeat aliquid deleniti dolore hic qui sed perferendis reiciendis excepturi expedita. Numquam eveniet quo labore hic rerum tempora beatae commodi animi officiis necessitatibus, mollitia quasi quas, dicta quam harum eligendi. Quis, suscipit debitis! Alias, obcaecati impedit culpa tenetur velit doloremque repudiandae quos, temporibus veniam sequi molestias nemo magni ad ratione voluptate dignissimos dicta a perspiciatis, laboriosam asperiores at non nostrum neque aliquid. Itaque accusantium debitis dolorum quibusdam ratione numquam consectetur exercitationem officia modi ad temporibus nam corrupti amet et in cumque sequi rem quae eum molestias tempora vero, quis maxime. Autem laborum unde praesentium accusantium explicabo vero facere ducimus asperiores vitae doloremque aut labore, accusamus illum mollitia. Maxime, ea. Consectetur laboriosam voluptates maxime corporis non vero impedit!</p>

    </div>
</div>
<div class="spacer60"></div>
<div class="squares-wrapper">
    <div class="squares">
        <div class="square">
            <div class="img-wrapper">
                <img src="./images/squares/fries-sq-1.jpg" alt="Fries WON">
            </div>
            <div class="square-text-wrapper">
                <h1>Lorem ipsum dolor sit amet consectetur adipisicing elit.</h1>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur amet accusantium deserunt! Quidem, necessitatibus distinctio? Aperiam repellendus eum quidem nemo, libero cumque, deserunt voluptatem quia adipisci dolorem a similique facere natus maiores maxime nesciunt iste? Nesciunt dolorem optio necessitatibus. In incidunt, quia aliquid ut culpa assumenda ratione. Iusto, corporis error.</p>
            </div>
        </div>
        <div class="square">
            <div class="square-text-wrapper">
                <h1>Lorem ipsum dolor sit amet consectetur adipisicing elit.</h1>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur amet accusantium deserunt! Quidem, necessitatibus distinctio? Aperiam repellendus eum quidem nemo, libero cumque, deserunt voluptatem quia adipisci dolorem a similique facere natus maiores maxime nesciunt iste? Nesciunt dolorem optio necessitatibus. In incidunt, quia aliquid ut culpa assumenda ratione. Iusto, corporis error.</p>
            </div>
            <div class="img-wrapper">
                <img src="./images/squares/fries-sq-2.jpg" alt="Fries TOO">
            </div>
        </div>
    </div>
</div>
<div class="footer">
    <div class="logo-footer">
        <img src="images/logos/decamp-fantastic-fries-logo-white.png" alt="Logo">
    </div>
    <div class="footer-phone-hours">
        <span class="phone">
            555 555 5555
        </span>
        <span class="hours">
            10 am - midnight
        </span>
    </div>
    <div class="links-wrapper">
        <div class="nav-link">
            <a href="index.html">Home</a> 
        </div>
        <div class="nav-link">
            <a href="about.html">About</a>
        </div>
        <div class="nav-link">
            <a href="menu.html">Menu</a>
        </div>
        <div class="nav-link">
            <a href="contact.html">Contact</a>  
        </div>
    </div>
    <div class="social-media-icons-wrapper">
        <a href="#">
            <i class="fa-brands fa-instagram"></i>
        </a>
        <a href="#">
            <i class="fa-brands fa-twitter"></i>
        </a>
        <a href="#">
            <i class="fa-brands fa-facebook"></i>
        </a>
    </div>
    <div class="copyright-wrapper">
        &copy; 2022 DevCamp &#124; All rights reserved
    </div>
</div>
</body>
</html>`
export default About;